<template>
	<div class="main-content container-fluid">
            <div class="col-12">
                <div class="row">
                <div class="col-8 mb-4">
                    <h1>{{ $t("date-ranges") }}</h1>
                </div>
                <div class="col-4 mb-4">
                    <button class="float-right btn btn-secondary mx-1" @click="addDateRange()"><b-icon icon="plus" />{{ $t("add") }}</button>
                </div>
            </div>
                <div class="list-group-item">
                    <div class="row">
                        <div class="col-md-1">
                            <span class="font-bold">{{ $t("id") }}</span>
                        </div>
                        <div class="col-md-3">
                            <span class="font-bold">{{ $t("from") }}</span>
                        </div>
                        <div class="col-md-3">
                            <span class="font-bold">{{ $t("to") }}</span>
                        </div>
                        <div class="col-md-2">
                            <span class="font-bold">{{ $t("number-of-rules") }}</span>
                        </div>
                    </div>
                </div>
                <div class="list-group" v-for="(dateRange, index) in dateRangesUpdated" :key="index">
                    <div class="list-group-item">
                        <div class="row">
                            <div class="col-md-1">{{ dateRange.id }}</div>
                            <div class="col-md-3">
                                        <input type="date" v-model="dateRange.datefrom" class="form-control"  v-if="dateRange.editing"><p class="mb-0" v-else>{{ $datetime.getLocaleStringFromISODate(dateRange.datefrom) }}</p>
                            </div>
                            <div class="col-md-3">
                                        <input type="date" v-model="dateRange.dateto" class="form-control"  v-if="dateRange.editing"><p class="mb-0" v-else>{{ $datetime.getLocaleStringFromISODate(dateRange.dateto) }}</p>
                            </div>
                            <div class="col-md-2"><p class="mb-0">{{ dateRange.num_rules }}</p></div>
                            <div class="col-md-3">
                                <button class="btn btn-primary" v-if="!dateRange.editing" @click="editDateRange(index)">{{ $t("edit") }}</button>
                                <button class="btn btn-danger mx-1" v-if="dateRange.editing" @click="deleteDateRange(dateRange)" >{{ $t('remove') }}</button>
                                <button class="btn btn-secondary mx-1" v-if="dateRange.editing" @click="saveDateRanges(dateRange,index)">{{ $t("save") }}</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
	</div>
</template>

<script>


export default {
	data: function () {
		return {
            dateRanges : null,
            error:null,
		};
	},
	mounted() {
		this.getDateRanges();
        //this adds an editing attribute to each entry in dateRanges
       //this.addEditing();
	},
	methods: {
		deleteDateRange(dateRange){
            this.$store.commit("openDialog", {
                    cancelBtn:true,
                    title: this.$t("delete-this-date-range-question"),
                    content: this.$t("date-range-deletion-warning", {i:this.$datetime.getLocaleStringFromISODate(dateRange.datefrom), f:this.$datetime.getLocaleStringFromISODate(dateRange.dateto), n:dateRange.num_rules}),
                    confirmCallBack: function () {
                        this.$cfetch(`${this.$settings.APIBaseURL}/timetable/ttteachertemplatedaterange/delete`, {
				            data: {
					            id: dateRange.id
				            }
			            }).then((res) => {
				            if (res.status === "SUCCESS") {
					            console.log(res);
                                this.getDateRanges();
				            }
			            }).catch((error) => {
				            this.$log.error.call(this, error);
			            });

                    }.bind(this)
            });
		},
		getDateRanges () {
			this.$cfetch(`${this.$settings.APIBaseURL}/timetable/ttteachertemplatedaterange/list`).then((res) => {
				if (res.status === "SUCCESS") {
					this.dateRanges = res.results;
                    this.addEditing();
				} else {
                    console.log(`Could not load date ranges`);
                }
			});
		},
        addEditing() {
            this.dateRanges.forEach(dateRange => {
            this.$set(dateRange, 'editing', false);
        });
        },
        editDateRange (index) {
         this.$set(this.dateRanges[index], 'editing', true);
		},
        addDateRange() {
            this.dateRanges.unshift({
                id: null,
                datefrom : null,
                dateto: null,
                editing: true,
                num_rules: '0'
            });
          },
        saveDateRanges (dateRange,index) {
            let dateFrom = new Date(dateRange.datefrom);
            let dateTo = new Date(dateRange.dateto);
            if (dateRange.datefrom == null || dateRange.dateto == null){
                this.$store.commit("openDialog", {
                    title: this.$t("error"),
                    content: this.$t("the-date-can-not-be-empty"),
            });
            } else if ( dateFrom > dateTo) {
                this.$store.commit("openDialog", {
                    title: this.$t("error"),
                    content: this.$t("the-starting-date-can-not-go-beyond-the-finishing-date"),
            });
            } else {
                this.$store.commit("showBlockingSpinner");
                this.$cfetch(`${this.$settings.APIBaseURL}/timetable/ttteachertemplatedaterange/save`, {
                    method: "post",
                    data: {
                    	id: dateRange.id ,
                    	datefrom: dateRange.datefrom ,
                    	dateto: dateRange.dateto
                    }
                })
                .then((res) => {
                    this.$store.commit("hideBlockingSpinner");
                    if (res.status === "SUCCESS") {
                        //this.$set(this.dateRanges[index], 'id', res.result.id);
                        this.$set(this.dateRanges[index], 'editing', false);
                    } else {
                        if (res.error_message) {
                            this.error = res.error_message;
                        } else {
                            this.error = "There was a problem saving the date range.";
                        }
                    }
                })
                .catch((error) => {
                this.$store.commit("hideBlockingSpinner");
                    this.$log.error.call(this, error);
                    this.error = "There was a problem saving the date ranges.";
                });
		    }
        }
	},
    computed: {
        dateRangesUpdated: {
			get() {
				return this.dateRanges;
			},
			set(newDateRange) {
				this.dateRanges = newDateRange;
			},
   	 	},
    }
};
</script>
